module.exports = __webpack_public_path__ + "assets/img/img-course-plan02.91460d66.png";